import gsap from "gsap";

(function() {
	document.addEventListener('pageLoad', () => {
		const nav = document.querySelector('.shows-archive-nav');
		if(! nav ) {
			return;
		}
		
		const selector = nav.querySelector('.shows-archive-nav--items-list');
		if(! selector ) {
			return;
		}
		
		const section = nav.closest('.app-section.has-shows-archive-nav');
		if(! section ) {
			return;
		}

		const btns = Array.from(nav.querySelectorAll('.shows-archive-nav--item-b'));
		const prevBtn = nav.querySelector('.shows-archive-nav--prev');
		const nextBtn = nav.querySelector('.shows-archive-nav--next');
		const gridEl = section.querySelector('.cards-grid');
		const archiveUrl = nav.dataset.archiveUrl ?? null;
		const maxIndex = btns.length - 1;
		
		const defaultIndex = (function() {
			const items = Array.from( nav.querySelectorAll('.shows-archive-nav--item') );
			const i = items.findIndex( item => item.classList.contains('current') );
			return i === -1 ? 0 : i;
		})();

		const indexFromHash = (function() {
			const raw = location.hash.replace(/^#/, '');
			if( ! raw ) {
				return null;
			}
			const i = btns.findIndex( b => (b.dataset.key || '') === raw );
			return i === -1 ? null : i;
		})();

		let currentIndex = indexFromHash || defaultIndex;
		
		

		const _hashForIndex = (index) => {
			const key = btns[index]?.dataset?.key;
			return key ? `#${key}` : '';
		};

		const _indexFromLocationHash = () => {
			const raw = location.hash.replace(/^#/, '');
			if( ! raw ) {
				return defaultIndex;
			}
			const i = btns.findIndex( b => (b.dataset.key || '') === raw );
			return i === -1 ? defaultIndex : i;
		};
		
		/*
		* Manage the visiblity of prev/next buttons 
		*/
		const _arrowBtnVisibility = (btn, isVisible) => {
			if( isVisible ) {
				return btn.classList.add('visible');
			}
			return btn.classList.remove('visible');
		}


		/*
		* Callback when a button is clicked 
		* @param {number} index
		*/
		const _handleClick = (index) => {
			const nextHash = _hashForIndex(index);
			if( nextHash && location.hash !== nextHash ) {
				location.hash = nextHash;
				return;
			}
			throw new Error('No url found for index: ' + index);
		}
		
		/*
		* Callback when URL changed
		* @param {number} index
		*/
		const _updateView = (index) => {
			_setContentVisibility(index);
			
			const cs = window.getComputedStyle(selector);
			const width = cs.getPropertyValue('--item-width');
			const value = parseFloat(width) * index * -1;	
			const unit = gsap.utils.getUnit(width);
			
			
			const first = currentIndex === index;
			if( first ) {
				gsap.set(selector, {
					x: `${value}${unit}`,
				});
			}
			else {
				gsap.to(selector, {
					x: `${value}${unit}`,
					duration: .5, 
					ease: 'power2.out',
				});
			}
			
			//selector.style.transform = `translateX(${value}${unit})`;
			btns.forEach(b => b.parentNode.classList.remove('current') );
			btns[index] && btns[index].parentNode.classList.add('current');
			currentIndex = index;	
			
			const prevVisibility = currentIndex > 0  ? true : archiveUrl !== null;
			_arrowBtnVisibility(prevBtn, prevVisibility);
			_arrowBtnVisibility(nextBtn, currentIndex < maxIndex);
		};
		
		
		const _setContentVisibility = (index) => {
			const first = currentIndex === index;
			const _elements = _index => {
				if( btns[_index] && btns[_index].dataset.key ) {
					return Array.from( gridEl.querySelectorAll(`.venue-${ btns[_index].dataset.key }`) );
				}
				return [];
			};
			
			if( first ) {
				if( btns[index] && btns[index].dataset.key ) {
					const els = Array.from( gridEl.querySelectorAll(`.cards-grid-item:not(.venue-${ btns[index].dataset.key })`) );
					gsap.set(els, { display: 'none' });
				}
				return;
			}
			
			const oldEls = _elements(currentIndex);
			const newEls = _elements(index);
			
			if( oldEls.length > 0 ) {	
				gsap.to(oldEls, { 
					autoAlpha: 0,
					duration: .25, 
					onComplete: () => gsap.set(oldEls, { display: 'none' }),
				});
			}
			
			if( newEls.length > 0 ) {
				gsap.to(newEls, { 
					autoAlpha: 1,
					duration: 1, 
					delay:.25,
					startAt: { opacity: 0, display: 'list-item' },
				});
			}
		};
		
		btns.forEach((btn, index) => {
			btn.addEventListener('click', () => _handleClick(index));
		});
		
		prevBtn.addEventListener('click', () => {
			if( currentIndex === 0 && archiveUrl ) {
				return document.location.href = archiveUrl;
			}
			return _updateView(currentIndex - 1);
		});
		
		nextBtn.addEventListener('click', () => {
			if( currentIndex >= maxIndex ) {
				return;
			}
			return _updateView(currentIndex + 1);
		});
		
		

		window.addEventListener('hashchange', () => {
			const idx = _indexFromLocationHash();
			_updateView(idx);
		});
		
		_updateView(currentIndex);
	});
})();
